"use client"

/**
 * Tarayıcı çeviri eklentileri (Google Translate / Chrome "Sayfayı çevir")
 * sayfadaki text node'ları kendi <font> etiketlerine sararak DOM'u değiştirir.
 * React sonradan o node'ları unmount/reorder etmek isteyince (özellikle Radix
 * Select/Dialog portal'larında) şu hata fırlar ve uygulama çöker:
 *   "removeChild: The node to be removed is not a child of this node"
 *   "insertBefore: The node before which the new node is to be inserted is not a child"
 *
 * Root layout'ta translate="no" ile çeviriyi zaten kapatıyoruz; bu bileşen,
 * manuel çeviri tetikleyen ya da agresif eklenti kullanan uç durumlar için
 * güvenlik ağıdır: ilgili DOM çağrıları hata fırlatmak yerine sessizce no-op olur.
 *
 * Ref: https://github.com/facebook/react/issues/11538
 */

let patched = false

function patchDomNodeMethods() {
  if (patched) return
  if (typeof Node !== "function" || !Node.prototype) return
  patched = true

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "[translation-guard] removeChild atlandı: düğüm bu parent'ın çocuğu değil (muhtemelen tarayıcı çevirisi DOM'u değiştirdi).",
          child,
        )
      }
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function insertBefore<T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "[translation-guard] insertBefore atlandı: referans düğüm bu parent'ın çocuğu değil (muhtemelen tarayıcı çevirisi DOM'u değiştirdi).",
          referenceNode,
        )
      }
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}

// Modül istemcide yüklenir yüklenmez (herhangi bir etkileşimden önce) patch'le.
if (typeof window !== "undefined") {
  patchDomNodeMethods()
}

export function TranslationGuard() {
  return null
}
